import { useQuery } from '@tanstack/react-query'
import apiClient from '@/apiClient'
import type { InventoryLevelsList, InventoryLevelsQuery } from '@/types/backend'

export const inventoryLevelsQK = {
  list: (q?: InventoryLevelsQuery) => ['inventory', 'levels', q ?? {}] as const,
}

export const useInventoryLevelsQuery = (
  q: InventoryLevelsQuery = {},
  enabled = true
) =>
  useQuery({
    queryKey: inventoryLevelsQK.list(q),
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<InventoryLevelsList>(
        '/inventory/levels',
        { params: q }
      )
      return data
    },
  })
